import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(CustomEase);

// Ease in
CustomEase.create('kota.easeIn.1', 'M0,0 C0.33,0 0.83,0.83 1,1');
CustomEase.create('kota.easeIn.2', 'M0,0 C0.76,0 0.83,0.83 1,1');
CustomEase.create('kota.easeIn.3', 'M0,0 C0.43,0 0.83,0.83 1,1');

// Ease out
CustomEase.create('kota.easeOut.1', 'M0,0 C0.17,0.17 0.19,1 1,1');
CustomEase.create('kota.easeOut.2', 'M0,0 C0.17,0.17 0.67,1 1,1');
CustomEase.create('kota.easeOut.3', 'M0,0 C0.17,0.17 0.32,1 1,1');
CustomEase.create('kota.easeOut.4', 'M0,0 C0.17,0.17 0.38,1 1,1 ');

// Ease inOut
CustomEase.create('kota.easeInOut.1', 'M0,0 C0.64,0 0.12,1 1,1');
CustomEase.create('kota.easeInOut.2', 'M0,0 C0.79,0 0.21,1 1,1');
CustomEase.create('kota.easeInOut.3', 'M0,0 C0.52,0 0.47,1 1,1');
CustomEase.create('kota.easeInOut.4', 'M0,0 C0.73,0 0.36,1 1,1');
CustomEase.create('kota.easeInOut.5', 'M0,0 C0.67,0 0.34,1 1,1');
CustomEase.create('kota.easeInOut.6', 'M0,0 C0.33,0 0.3,1 1,1');
CustomEase.create('kota.easeInOut.7', 'M0,0 C0.33,0 0.4,1 1,1');
CustomEase.create('kota.easeInOut.8', 'M0,0 C0.67,0 0.37,1 1,1');